const monthlyPriceId = process.env.REACT_APP_MONTHLY_PLAN_ID;
const quarterlyPriceId = process.env.REACT_APP_QUARTERLY_PLAN_ID;
const annualPriceId = process.env.REACT_APP_YEARLY_PLAN_ID;
const twoVideoAnuualPriceId = process.env.REACT_APP_YEARLY_TWO_VIDEO_PLAN;
const weekPlan = process.env.REACT_APP_WEEK_PLAN;
const biweeklyPlan = process.env.REACT_APP_BI_WEEK_PLAN;

export const products =[
  {
    id: monthlyPriceId,
    name: 'Pay As You Go',
    description: 'A convenient option that allows you to produce videos on a monthly basis while paying as you go. Enjoy the same professional Snapshot Video experience without the need for an annual commitment.',
    type: 'service',
    unit_amount: 100000,
    interval: 'month',
  },
  {
    id: quarterlyPriceId,
    name: 'Quarterly – 4 Videos/yr',
    description: 'Receive a fresh new video every quarter to highlight key initiatives, showcase important updates, and keep your members and industry engaged year-round.',
    type: 'service',
    unit_amount: 300000,
    interval: 'year',
  },
  {
    id: annualPriceId,
    name: 'Monthly - 12 Videos/yr',
    description: 'Designed for organizations that distribute a newsletter every month. Each issue is transformed into a polished video, ensuring your members receive consistent, engaging updates 12 times a year.',
    type: 'service',
    unit_amount: 900000,
    interval: 'year',
  },
  // {
  //   id: twoVideoAnuualPriceId,
  //   name: '24 Snapshots - Annual Subscription',
  //   description: 'This plan is best for yearly subscribers. You will get 24 videos for the year.',
  //   type: 'service',
  //   unit_amount: 1800000,
  //   interval: 'year',
  // },
  {
    id: biweeklyPlan,
    name: 'Biweekly – 26 Videos/yr',
    description: 'Best for associations that send a newsletter every other week. With 26 videos annually, this option mirrors your publishing schedule and ensures members receive timely, engaging updates all year long.',
    type: 'service',
    unit_amount: 1950000,
    interval: 'year',
  },
  {
    id: weekPlan,
    name: 'Weekly – 52 Videos/yr',
    description: 'Ideal for organizations that send a newsletter every week. Each edition is repurposed into a professional Snapshot Video, 52 per year, delivering timely updates that match your communication rhythm.',
    type: 'service',
    unit_amount: 3900000,
    interval: 'year',
  },
]

// Get all products
export function getAllPlans() {
  return products;
}

// Get single plan by Price ID
export function getPlanById(priceId) {
  return products.find((plan) => plan.id === priceId) || null;
}